/**
 * The label lengths Meta documents for its question components, which it does not refuse on
 * upload but flags on a phone: a draft flow opened on 2026-10-16 showed "TextArea 'improvements'
 * 'label' must be 20 characters or less to avoid truncation on different screen sizes" for a
 * 28-character label, while Meta's validation_errors stayed empty. So this is a warning, not an
 * error. The numbers are the "Limits and restrictions" tables of Meta's components reference.
 */
export const RECOMMENDED_LABEL_LENGTH = Object.freeze({
  TextInput: 20,
  TextArea: 20,
  Dropdown: 20,
  RadioButtonsGroup: 30,
  CheckboxGroup: 30,
});

/** The warning for a label longer than WhatsApp shows in full, or none. */
export const labelLengthWarnings = (type, label) => {
  const max = RECOMMENDED_LABEL_LENGTH[type];
  if (!max || typeof label !== 'string' || label.length <= max) return [];
  return [`Label is ${label.length} characters. WhatsApp may cut off a label over ${max} on smaller screens: shorten it, and put the full question in a TextBody above`];
};
